import React, { Fragment, useContext, useState } from 'react';
/// React router dom
import { Link } from 'react-router-dom';
import { ThemeContext } from '@context/ThemeContext';
import logo from '@images/logo.png';
import logoFull from '@images/logo-full.png';
import logoWhite from '@images/logo-white.png';
import logoFullWhite from '@images/logo-full-white.png';

export function NavMenuToggle() {
  setTimeout(() => {
    let mainwrapper = document.querySelector('#main-wrapper');
    if (mainwrapper.classList.contains('menu-toggle')) {
      mainwrapper.classList.remove('menu-toggle');
    } else {
      mainwrapper.classList.add('menu-toggle');
    }
  }, 200);
}

const NavHader = () => {
  const [toggle, setToggle] = useState(false);
  const { navigationHader, openMenuToggle, background } =
    useContext(ThemeContext);

  return (
    <div className="nav-header">
      <Link to="/" className="brand-logo">
        {background.value === 'dark' || navigationHader !== 'color_1' ? (
          <Fragment>
            <img height={60} src={toggle ? logoWhite : logoFullWhite} alt="" />
          </Fragment>
        ) : (
          <Fragment>
            <img height={60} src={toggle ? logo : logoFull} alt="" />
          </Fragment>
        )}
      </Link>
      <div
        className="nav-control"
        onClick={() => {
          setToggle(!toggle);
          NavMenuToggle();
        }}
      >
        <div className={`hamburger ${toggle ? 'is-active' : ''}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
